import React from "react"
import { useTranslation } from "react-i18next"

import { Content, Card } from "pages/static/elements"
import Title from "components/ui/Title"
import Table from "components/ui/Table"
import { STRING_STRONG_TYPE, STRING_CENTER_TYPE } from "config"

const SubscriptionTermsPage = () => {
  const { t } = useTranslation()

  const HEADER = [
    {
      label: "",
      field: "description",
      format: STRING_STRONG_TYPE,
      minWidth: 100,
    },
    {
      label: t("features.plan.table.header.standard"),
      field: "standard",
      format: STRING_CENTER_TYPE,
      minWidth: 100,
    },
    {
      label: t("features.plan.table.header.silver"),
      field: "silver",
      format: STRING_CENTER_TYPE,
      minWidth: 100,
    },
    {
      label: t("features.plan.table.header.gold"),
      field: "gold",
      format: STRING_CENTER_TYPE,
      minWidth: 100,
    },
  ]

  return (
    <Content data-testid="subscription-page">
      <Title>{t("pages.subscription-terms.title")}</Title>
      <Card>
        <Table
          header={HEADER}
          items={t("features.plan.table.items")}
          fade={false}
        />
      </Card>
    </Content>
  )
}

export default SubscriptionTermsPage
